<script>
export default {
    name: 'PolicyPage',
};
</script>

<script setup>
import CardsPage from '@/pages/components/cards-page.vue';
import { instance } from '@/api/api.ts';
</script>

<template>
    <cards-page
        :title="$t('header breadcrumb policy')"
        :fetch="() => instance.get('/policy')"
    />
</template>
